import { render, staticRenderFns } from "./ProfilePresence.vue?vue&type=template&id=f15727fe&"
import script from "./ProfilePresence.vue?vue&type=script&lang=js&"
export * from "./ProfilePresence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports